import {Component, Inject, Vue} from "vue-property-decorator";
import {UserBox} from "~/components/user-box";
import {Logo} from "~/components/logo";
import {isDefined} from "~/lib/helpers/guards";
import {Nav} from "~/components/nav";
import {NavGoBackLink} from "~/components/nav-go-back-link";
import {AppSettings} from "~/lib/app-settings";

@Component
export class Sidebar extends Vue {
  @Inject() appSettings: AppSettings;

  render(){
    return (
      <div class="sidebar">
        <div class={"sidebar__header"}>
          {isDefined(this.$customisation('navbarLogo')) && <Logo logo={{
            fileId: this.$customisation('navbarLogo').fileId,
            width: this.$customisation('navbarLogo').width
          }} />}
          <NavGoBackLink />
          {this.appSettings.hasClients && <p class={"sidebar__client-name"}>{this.appSettings.client?.name}</p>}
        </div>
        <Nav />
        <UserBox />
      </div>
    )
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-4ab40826/sidebar.tsx" });